import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';
import { FeatureToggleValues } from '../model/feature-toggles.model';

const withNameSpace = withGenesysCloudStoreNameSpace('Feature Toggles');

export const initializeModule = createAction(
  withNameSpace('Initialize module')
);

export const loadAllFeatureToggles = createAction(
  withNameSpace('Load all feature toggles')
);

export const allFeatureTogglesLoaded = createAction(
  withNameSpace('All feature toggles loaded'),
  props<{ featureToggles: FeatureToggleValues }>()
);
